import { useUserPermissions } from './useUserPermissions';
import { canAct, type FdAction, type FdSection } from '../utils/frontDeskMatrix';

/**
 * Whether a control should show: the tenant Front Desk and the estate group roles get their static matrix for
 * `section` / `action`; everyone else keeps `otherwise` (the page's own check, true when the page had none).
 */
export const useFdCan = (section: FdSection, action: FdAction, otherwise = true): boolean =>
  canAct(useUserPermissions(), section, action, otherwise);
